import React, { useCallback } from "react";
import Button from "shared/Button";
import { Filters, Item, ItemWrap } from "../../components/ProfilePage/styled";
import { useSelector } from "react-redux";
import { isUserBuyer } from "store/userReducer/userSelectors";
import { useRouter } from "next/router";

// isDisable — boolean
// updateItems - fc for updating items
// setFilter - fc for setting filter option
// activeFilterOption - string
// filterOptions - string[]

const FiltersMenu = ({
  isDisable,
  updateItems,
  setFilter,
  activeFilterOption,
  filterOptions,
  onFilterChanging,
  filterText,
}) => {
  const isBuyer = useSelector(isUserBuyer);
  const router = useRouter();

  const { applyFilter } = useFiltersMenu({
    updateItems,
    setFilter,
    onFilterChanging,
  });

  if (isBuyer && router.route !== "/library") return null;

  return (
    <Filters>
      <ItemWrap>
        {filterOptions.map((option, i) => {
          return (
            <Item isActive={activeFilterOption === option} key={option}>
              <Button
                onClick={() => applyFilter(option)}
                btnSize="small"
                stylType="master"
                text={filterText ? filterText[i] : ""}
                disabled={isDisable}
              />
            </Item>
          );
        })}
      </ItemWrap>
    </Filters>
  );
};

// updateItems — экшен для обновленния содержимого
// setFilter — экшен для установления фильтра

export const useFiltersMenu = ({ updateItems, setFilter, onFilterChanging }) => {
  const applyFilter = useCallback((option) => {
    setFilter(option);
    onFilterChanging && onFilterChanging();
    updateItems && updateItems();
  }, []);

  return { applyFilter };
};

export default FiltersMenu;
